import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import { debounce } from './utilities.js';

Alpine.plugin(collapse);

Alpine.data('vcard', (data) => ({
  ...data,
  download() {
    const vcf = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${this.name};;;`,
      `FN:${this.name}`,
      `ORG:${this.firm}`,
      `TITLE:${this.title}`,
      `EMAIL:${this.email}`,
      `TEL:${this.phone}`,
      `URL:${this.url}`,
      'END:VCARD',
    ].join('\r\n');

    const blob = new Blob([vcf], { type: 'text/vcard' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.filename;
    link.click();
    URL.revokeObjectURL(link.href);
  },
}))

window.Alpine = Alpine
Alpine.start()
